export const getDate = () => {
  return new Date()
}
